import Vue from 'vue'
import Router from 'vue-router'

const Home = () => import(/* webpackChunkName: "Home" */ '@/components/Home')
Vue.use(Router)

var router = new Router({
  routes: [{
    path: '/',
    component: Home
  }]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js